import { Component, Input, Output, EventEmitter, OnInit, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TemplateNode } from '../certification-template-editor.component';

export interface CertificateValueNode {
  name: string;
  type: string;
  nodeId: string;           // references TemplateNode.id
  value?: string | number;  // leaf value (string/number)
  children?: CertificateValueNode[]; // for object-like nodes (with children)
}

@Component({
  selector: 'app-template-value-node-editor',
  templateUrl: './template-value-node-editor.component.html',
  styleUrls: ['./template-value-node-editor.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    forwardRef(() => TemplateValueNodeEditorComponent)
  ]
})
export class TemplateValueNodeEditorComponent implements OnInit {
  @Input() templateNode: TemplateNode;
  @Input() valueNode: CertificateValueNode;
  @Output() valueChange = new EventEmitter<void>();

  get hasChildren(): boolean {
    return !!(this.templateNode.children && this.templateNode.children.length > 0);
  }

  ngOnInit(): void {
    if (this.hasChildren) {
      if (!this.valueNode.children) {
        this.valueNode.children = this.templateNode.children.map(t => ({
          name: t.name,
          type: t.type,
          nodeId: t.id,
          value: undefined,
          children: t.children && t.children.length > 0 ? [] : undefined
        }));
      }
    }
  }

  onValueChanged() {
    this.valueChange.emit();
  }

  onChildValueChange() {
    this.valueChange.emit();
  }
}